import { OrdenPagoRutas, GetResponseBody, GetHeaderRequest } from './RutasConfig';

export const Obtener_Pago_Referencias_Tarjetas = async (pToken, EmpresaId, CallCenterId, OrdenId) => {
    const data = { EmpresaId, CallCenterId, OrdenId };
    const result = await fetch(OrdenPagoRutas.Obtener_Pago_Referencias_Tarjetas, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};